var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"zm-form",class:[
    _vm.labelPosition ? 'zm-form--label-' + _vm.labelPosition : '',
    { 'zm-form--inline': _vm.inline }
  ],attrs:{"action":"javascript:;"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }